import React from 'react';
import { ThemeProvider } from 'styled-components';
import getGlobalProps from '../../../helpers/constants/global-props';

import ProgressBarItem from './ProgressBarItem/ProgressBarItem';
import getProportion from '../helpers/getProportion';
import sortByProportionDesc from '../helpers/sortByProportionDesc';

import { SizeType } from '../Progress';
import { ProgressBarWrapper } from '../styles';

export interface BarDatum {
  proportion: number;
  color: string;
  tooltip?: string;
}

export interface ProgressBarProps {
  data: Array<BarDatum>;
  size: SizeType;
  loading?: boolean;
  'aria-label'?: string;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Graphically display proportion along a bar
 */
function ProgressBar(props: ProgressBarProps) {
  const { size, data, loading, 'aria-label': ariaLabel } = props;

  const renderBars = () => {
    const dataSortedByProportion = sortByProportionDesc(data);
    return dataSortedByProportion.map((datum, index) => {
      const proportion = getProportion(datum.proportion);
      return (
        <ProgressBarItem aria-label={ariaLabel} key={`bar_${index}`} width={proportion} datum={datum} size={size} />
      );
    });
  };

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        size,
        loading,
      })}
    >
      <ProgressBarWrapper {...globalProps}>{!loading && renderBars()}</ProgressBarWrapper>
    </ThemeProvider>
  );
}

export default ProgressBar;
